<template>
  <div>
    <div class="bax-order-summary bax-form-ref-edit-error">
      <ul>
        <li class="d-md-flex">
          <span>Order Reference: </span>
          <strong v-if="!editingOrder" class="ml-auto text-right">{{ order.orderRefView }}</strong>
          <input
            v-if="editingOrder"
            v-model="editedOrderRef"
            type="text"
            class="ml-auto text-right"
          />
        </li>
        <p v-if="!this.orderReferenceRequired">Required field</p>
        <p v-if="!this.orderReferenceMax">Max character allowed is 20</p>
        <li class="d-md-flex">
          <span>Date Required: </span>
          <strong class="ml-auto text-right">{{ order.deliveryDate }}</strong>
        </li>
        <li class="d-md-flex" v-if="!isTPN()">
          <span>Time Required: </span>
          <strong class="ml-auto text-right">{{
            order.deliveryTime ? order.deliveryTime : "--:--"
          }}</strong>
        </li>
        <li class="d-md-flex" v-if="!isTPN()">
          <span>Patients: </span>
          <strong class="ml-auto text-right">
            {{ order.patientCount }}
          </strong>
        </li>
        <li class="d-md-flex">
          <span>Items Ordered: </span>
          <strong class="ml-auto text-right">{{ order.drugCount }}</strong>
        </li>
        <li class="d-md-flex comment">
          <span>Comment: </span>
          <strong class="ml-auto text-right" style="display: block" v-if="!editingOrder">
            {{ order.comment }}
          </strong>
          <textarea v-if="editingOrder" v-model="editedComment"></textarea>
          <template v-if="authenticatedUser.baxterRoles.can_create_edit_orders">
            <a
              href="javascript:;"
              class="bax-btn bax-btn-white comment-edit"
              v-if="!editingOrder"
              @click.prevent="
                editedComment = order.comment;
                editingOrder = true;
              "
            >
              <i class="icon-edit"></i>Edit
            </a>
            <a
              href="javascript:;"
              class="bax-btn bax-btn-white comment-edit comment-cancel"
              v-if="editingOrder"
              @click.prevent="editingOrder = false"
            >
              <i class="icon-cancel"></i>Cancel
            </a>
            <a
              href="javascript:;"
              class="bax-btn bax-btn-white comment-edit"
              v-if="editingOrder"
              @click.prevent="saveOrder()"
            >
              <i class="icon-save"></i>Save
            </a>
          </template>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import OrderDrugService from "@/core/api/order/orderDrug.service";
import tpnMixin from "@/mixins/tpnMixin";
import { mapGetters } from 'vuex';

export default {
  name: "OrderSummaryInfo",
  mixins: [tpnMixin],
  props: {
    order: {
      type: Object,
    },
  },
  watch: {
    order(newOrderVal) { // watch it
     // console.log('Prop changed: ', newVal, ' | was: ', oldVal);
      this.editedComment = newOrderVal.comment;
      this.editedOrderRef = newOrderVal.orderRefView;
    },
  },
  data() {
    return {
      editingOrder: false,
      editedComment: "empty",
      editedOrderRef: "",
      orderReferenceRequired: true,
      orderReferenceMax: true,
    };
  },
  computed: {
        ...mapGetters(['authenticatedUser']),
    },
  async created() {
    this.editedComment = this.order.comment;
    this.editedOrderRef = this.order.orderRefView;
  },
  methods: {
    updateURL(existingOrderRefView) {
      const currentURL = window.location.href;
      const existingOrderRefViewEncoded = encodeURIComponent(existingOrderRefView);
      const editedOrderRefEncoded = encodeURIComponent(this.editedOrderRef);
      const newURL = currentURL.replace(existingOrderRefViewEncoded, editedOrderRefEncoded);
      window.history.pushState({}, "", newURL);
      window.location.reload();
    },
    saveOrder() {
      if (this.editedOrderRef === '') {
        this.orderReferenceRequired = false;
        this.orderReferenceMax = true;
      } else if (this.editedOrderRef.length > 20) {
        this.orderReferenceMax = false;
        this.orderReferenceRequired = true;
      } else {
        this.orderReferenceMax = true;
        this.orderReferenceRequired = true;
        const data = {
          orderRef: this.$route.params.orderId,
          orderRefView: this.order.orderRefView,
          updateOrderRefView: this.editedOrderRef,
          updatecomment: this.editedComment,
      };

      const existingOrderRefView = this.order.orderRefView

      OrderDrugService.updateDrug(data)
        .then(() => {
          this.editingOrder = false;
          this.order.orderRefView = this.editedOrderRef;
          this.updateURL(existingOrderRefView);
        })
        .catch((e) => e);
      }
    },
  },
};
</script>
